// extracted by mini-css-extract-plugin
module.exports = {"capitalize":"ljHjO","link":"IMUal"};